import { Component } from '@angular/core';

import { Router } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';

import { labelBanco } from 'src/app/enum/banco-integracao.enum';

import { ContaCorrenteService } from 'src/app/service/contaCorrente.service';

import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';

import { ContaCorrente } from './contacorrente';



@Component({

  selector: 'app-conta-corrente-consulta',

  templateUrl: './conta-corrente-consulta.component.html',

  styleUrls: [

    './conta-corrente-shared.scss',

    '../../util/conta-financeira/conta-financeira-consulta.scss',

  ],

})

export class ContaCorrenteConsultaComponent {



  contas: ContaCorrente[] = [];

  labelBanco = labelBanco;

  consultaRealizada = false;

  tipoFiltros = ['ID', 'Nome'];

  tipoFiltro = 'ID';

  parametro = '';

  situacao: boolean | null = null;

  private todasContas: ContaCorrente[] = [];



  constructor(

    private service: ContaCorrenteService,

    private snackBar: MatSnackBar,

    private router: Router,

  ) { }



  onFiltroChange() {

    this.consultaRealizada = false;

    this.contas = [];

  }



  consultar() {

    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);

    if (idFiltro != null) {

      this.service.buscar(idFiltro).subscribe(conta => {

        const lista = aplicarFiltrosConsulta([conta], this.tipoFiltro, this.parametro, this.situacao, {

          id: c => c.id,

          nome: c => c.descricao,

          ativo: c => c.ativa !== false,

        });

        this.contas = lista;

        this.consultaRealizada = true;

        if (lista.length === 0) {

          this.snackBar.open('Conta corrente não encontrada.', 'ERRO', { duration: 2500 });

        }

      }, () => this.snackBar.open('Conta corrente não encontrada.', 'ERRO', { duration: 2500 }));

      return;

    }



    const aplicar = () => {

      this.contas = aplicarFiltrosConsulta(this.todasContas, this.tipoFiltro, this.parametro, this.situacao, {

        id: c => c.id,

        nome: c => c.descricao,

        ativo: c => c.ativa !== false,

      });

      this.consultaRealizada = true;

    };



    if (this.todasContas.length) {

      aplicar();

      return;

    }



    this.service.listar().subscribe(lista => {

      this.todasContas = lista ?? [];

      aplicar();

    }, () => this.snackBar.open('Erro ao listar contas correntes.', 'ERRO', { duration: 2500 }));

  }



  novo() {

    this.router.navigate(['/contaCorrente/form']);

  }



  editar(conta: ContaCorrente) {

    if (conta.id) {

      this.router.navigate(['/contaCorrente/form', conta.id]);

    }

  }



  excluir(conta: ContaCorrente) {

    if (!conta.id || !confirm('Inativar esta conta corrente?')) {

      return;

    }

    this.service.excluir(conta.id).subscribe(() => {

      this.snackBar.open('Conta inativada.', 'OK', { duration: 2000 });

      this.todasContas = [];

      this.consultar();

    });

  }

}

